module.exports = __webpack_public_path__ + "img/Wood-floor-parquet-bright-texture-3d-BPR-free-download-seamless-HD-4K-render-full.b153377e.jpg";